import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Components
import Sidebar from './components/Sidebar';
import Setup from './pages/Setup';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Charts from './pages/Charts';
import Budget from './pages/Budget';
import Upcoming from './pages/Upcoming';
import Forecast from './pages/Forecast';
import CLI from './pages/CLI';
import Settings from './pages/Settings';

function App() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load config from localStorage
    const savedConfig = localStorage.getItem('hledger-config');
    if (savedConfig) {
      setConfig(JSON.parse(savedConfig));
    }
    setLoading(false);
  }, []);

  const saveConfig = (newConfig) => {
    setConfig(newConfig);
    localStorage.setItem('hledger-config', JSON.stringify(newConfig));
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // If no config, show setup
  if (!config) {
    return <Setup onComplete={saveConfig} />;
  }

  return (
    <Router>
      <div className="app">
        <Sidebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard config={config} />} />
            <Route path="/transactions" element={<Transactions config={config} />} />
            <Route path="/charts" element={<Charts config={config} />} />
            <Route path="/budget" element={<Budget config={config} />} />
            <Route path="/upcoming" element={<Upcoming config={config} />} />
            <Route path="/forecast" element={<Forecast config={config} />} />
            <Route path="/cli" element={<CLI config={config} />} />
            <Route path="/settings" element={<Settings config={config} onSave={saveConfig} />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
